(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

	  customElements.define('sticky-header', StickyHeader);

	  /**
	   * 关闭同一抽屉内其它已展开项
	   */
	  function closeOtherNelkoHeaderDrawerAccordions(details) {
	    const drawer = details.closest('.nelko-home-header__drawer')

	    if (!drawer) return

	    drawer.querySelectorAll('[data-drawer-accordion][open]').forEach(function closeAccordion(item) {
	      if (item !== details) {
	        item.removeAttribute('open')
	      }
	    })
	  }

	  /**
	   * 初始化移动端 Header 抽屉手风琴
	   */
	  function initNelkoHeaderDrawerAccordion() {
	    document.querySelectorAll('[data-drawer-accordion]').forEach(function initAccordion(details) {
	      details.addEventListener('toggle', function onAccordionToggle() {
	        if (!details.open) return

	        closeOtherNelkoHeaderDrawerAccordions(details)
	      })
	    })
	  }

	  /**
	   * 阻止桌面下拉面板区域把滚动传递给页面
	   */
	  function preventNelkoHeaderMegaScroll(event) {
	    event.preventDefault()
	  }

	  /**
	   * 初始化桌面 Header 下拉面板滚动隔离
	   */
	  function initNelkoHeaderMegaScrollLock() {
	    document.querySelectorAll('.nelko-home-header__mega').forEach(function initMegaPanel(panel) {
	      panel.addEventListener('wheel', preventNelkoHeaderMegaScroll, { passive: false })
	      panel.addEventListener('touchmove', preventNelkoHeaderMegaScroll, { passive: false })
	    })
	  }

	  /**
	   * 获取桌面下拉动画时长
	   */
	  function getNelkoHeaderMegaAnimationMs(panel) {
	    const duration = Number.parseFloat(window.getComputedStyle(panel).animationDuration)

	    if (Number.isNaN(duration) || duration <= 0) return 0

	    return duration * 1000
	  }

	  /**
	   * 完成桌面下拉打开动画
	   */
	  function finishNelkoHeaderMegaOpen(details) {
	    details.classList.remove('is-opening')
	  }

	  /**
	   * 完成桌面下拉关闭动画
	   */
	  function finishNelkoHeaderMegaClose(details) {
	    details.classList.remove('is-closing')
	    details.removeAttribute('open')
	  }

	  /**
	   * 关闭其它桌面 Header 下拉面板
	   */
	  function closeOtherNelkoHeaderMegas(currentDetails) {
	    document.querySelectorAll('.nelko-home-header__mega-details[open]').forEach(function closeMega(details) {
	      if (details !== currentDetails) {
	        details.classList.remove('is-opening', 'is-closing')
	        details.removeAttribute('open')
	      }
	    })
	  }

	  /**
	   * 关闭 Header Search 面板
	   */
	  function closeNelkoHeaderSearch(details) {
	    details.removeAttribute('open')
	  }

	  /**
	   * 关闭其它 Header Search 面板
	   */
	  function closeOtherNelkoHeaderSearchPanels(currentDetails) {
	    document.querySelectorAll('[data-search-details][open]').forEach(function closeSearch(details) {
	      if (details !== currentDetails) {
	        closeNelkoHeaderSearch(details)
	      }
	    })
	  }

	  /**
	   * 聚焦 Header Search 输入框
	   */
	  function focusNelkoHeaderSearchInput(details) {
	    const input = details.querySelector('.nelko-home-search-panel__input')

	    if (!input) return

	    window.setTimeout(function onSearchFocusTimer() {
	      input.focus()
	    }, 0)
	  }

	  /**
	   * 初始化 Header Search 面板
	   */
	  function initNelkoHeaderSearchPanels() {
	    document.querySelectorAll('[data-search-details]').forEach(function initSearchDetails(details) {
	      details.addEventListener('toggle', function onSearchToggle() {
	        if (!details.open) return

	        closeOtherNelkoHeaderSearchPanels(details)
	        closeOtherNelkoHeaderMegas()
	        document.querySelectorAll('.nelko-home-header__drawer-details[open]').forEach(function closeDrawer(drawer) {
	          drawer.removeAttribute('open')
	        })
	        focusNelkoHeaderSearchInput(details)
	      })

	      details.querySelectorAll('[data-search-close]').forEach(function initSearchClose(button) {
	        button.addEventListener('click', function onSearchCloseClick() {
	          closeNelkoHeaderSearch(details)
	        })
	      })
	    })
	  }

	  const nelkoHeaderDesktopMedia = window.matchMedia('(min-width: 1024px)')
	  const nelkoHeaderDesktopHoverMedia = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)')
	  let nelkoHeaderWasDesktop = nelkoHeaderDesktopMedia.matches
	  let nelkoHeaderMegaCloseTimer = null

	  /**
	   * 判断当前是否使用桌面 Hover 下拉
	   */
	  function isNelkoHeaderDesktopHoverMode() {
	    return nelkoHeaderDesktopHoverMedia.matches
	  }

	  /**
	   * 清理桌面 Header 下拉延迟关闭定时器
	   */
	  function clearNelkoHeaderMegaCloseTimer() {
	    if (!nelkoHeaderMegaCloseTimer) return

	    window.clearTimeout(nelkoHeaderMegaCloseTimer)
	    nelkoHeaderMegaCloseTimer = null
	  }

	  /**
	   * 延迟关闭桌面 Header 下拉
	   */
	  function scheduleNelkoHeaderMegaClose(details) {
	    clearNelkoHeaderMegaCloseTimer()

	    nelkoHeaderMegaCloseTimer = window.setTimeout(function onMegaCloseDelayTimer() {
	      nelkoHeaderMegaCloseTimer = null

	      if (!details.open || details.classList.contains('is-closing')) return

	      closeNelkoHeaderMega(details)
	    }, 120)
	  }

	  /**
	   * 获取桌面端已打开的下拉标签
	   */
	  function getNelkoHeaderOpenMegaLabel() {
	    const details = document.querySelector('.nelko-home-header__mega-details[open]')

	    if (!details) return ''

	    const summary = details.querySelector('.nelko-home-header__mega-summary')

	    if (!summary) return ''

	    return summary.textContent.trim()
	  }

	  /**
	   * 获取移动端抽屉里已打开的下拉标签
	   */
	  function getNelkoHeaderOpenDrawerAccordionLabel() {
	    const details = document.querySelector('[data-drawer-accordion][open]')

	    if (!details) return ''

	    const label = details.querySelector('.nelko-home-header__drawer-link span:first-child')

	    if (!label) return ''

	    return label.textContent.trim()
	  }

	  /**
	   * 打开指定标签的移动端抽屉下拉
	   */
	  function openNelkoHeaderDrawerAccordionByLabel(label) {
	    const drawer = document.querySelector('.nelko-home-header__drawer-details')

	    if (!drawer || !label) return

	    drawer.setAttribute('open', '')
	    document.querySelectorAll('[data-drawer-accordion]').forEach(function syncAccordion(details) {
	      const labelNode = details.querySelector('.nelko-home-header__drawer-link span:first-child')
	      const itemLabel = labelNode ? labelNode.textContent.trim() : ''

	      if (itemLabel === label) {
	        details.setAttribute('open', '')
	        return
	      }

	      details.removeAttribute('open')
	    })
	  }

	  /**
	   * 打开指定标签的桌面端下拉
	   */
	  function openNelkoHeaderMegaByLabel(label) {
	    if (!label) return

	    document.querySelectorAll('.nelko-home-header__mega-details').forEach(function syncMega(details) {
	      const summary = details.querySelector('.nelko-home-header__mega-summary')
	      const itemLabel = summary ? summary.textContent.trim() : ''

	      if (itemLabel === label) {
	        openNelkoHeaderMega(details)
	      }
	    })
	  }

	  /**
	   * 打开当前断点对应的 Search 面板
	   */
	  function openNelkoHeaderSearchForViewport(isDesktop) {
	    const selector = isDesktop ? '.nelko-home-header__search-details--desktop' : '.nelko-home-header__search-details--mobile'
	    const details = document.querySelector(selector)

	    if (!details) return

	    details.setAttribute('open', '')
	    focusNelkoHeaderSearchInput(details)
	  }

	  /**
	   * 同步 Header 跨断点的打开状态
	   */
	  function syncNelkoHeaderResponsiveState() {
	    const isDesktop = nelkoHeaderDesktopMedia.matches

	    if (isDesktop === nelkoHeaderWasDesktop) return

	    if (isDesktop) {
	      const mobileSearchIsOpen = Boolean(document.querySelector('.nelko-home-header__search-details--mobile[open]'))
	      const drawerLabel = getNelkoHeaderOpenDrawerAccordionLabel()

	      closeOtherNelkoHeaderSearchPanels()
	      document.querySelectorAll('.nelko-home-header__drawer-details[open]').forEach(function closeDrawer(drawer) {
	        drawer.removeAttribute('open')
	      })

	      if (mobileSearchIsOpen) {
	        openNelkoHeaderSearchForViewport(true)
	      } else if (drawerLabel) {
	        openNelkoHeaderMegaByLabel(drawerLabel)
	      }
	    } else {
	      const desktopSearchIsOpen = Boolean(document.querySelector('.nelko-home-header__search-details--desktop[open]'))
	      const megaLabel = getNelkoHeaderOpenMegaLabel()

	      closeOtherNelkoHeaderSearchPanels()
	      closeOtherNelkoHeaderMegas()

	      if (desktopSearchIsOpen) {
	        openNelkoHeaderSearchForViewport(false)
	      } else if (megaLabel) {
	        openNelkoHeaderDrawerAccordionByLabel(megaLabel)
	      }
	    }

	    nelkoHeaderWasDesktop = isDesktop
	  }

	  /**
	   * 初始化 Header 跨断点状态同步
	   */
	  function initNelkoHeaderResponsiveStateSync() {
	    nelkoHeaderDesktopMedia.addEventListener('change', syncNelkoHeaderResponsiveState)
	  }

	  /**
	   * 打开桌面 Header 下拉面板
	   */
	  function openNelkoHeaderMega(details) {
	    const panel = details.querySelector('.nelko-home-header__mega')

	    if (!panel) return

	    clearNelkoHeaderMegaCloseTimer()
	    closeOtherNelkoHeaderMegas(details)
	    closeOtherNelkoHeaderSearchPanels()

	    if (details.open && !details.classList.contains('is-closing')) return

	    details.classList.remove('is-closing', 'is-opening')
	    details.setAttribute('open', '')
	    panel.getBoundingClientRect()
	    details.classList.add('is-opening')
	    window.setTimeout(function onMegaOpenTimer() {
	      finishNelkoHeaderMegaOpen(details)
	    }, getNelkoHeaderMegaAnimationMs(panel))
	  }

	  /**
	   * 关闭桌面 Header 下拉并播放退出动画
	   */
	  function closeNelkoHeaderMega(details) {
	    const panel = details.querySelector('.nelko-home-header__mega')

	    if (!panel) return
	    if (!details.open || details.classList.contains('is-closing')) return

	    clearNelkoHeaderMegaCloseTimer()
	    details.classList.remove('is-opening', 'is-closing')
	    panel.getBoundingClientRect()
	    details.classList.add('is-closing')
	    window.setTimeout(function onMegaCloseTimer() {
	      finishNelkoHeaderMegaClose(details)
	    }, getNelkoHeaderMegaAnimationMs(panel))
	  }

	  /**
	   * 初始化桌面 Header 下拉开合动画
	   */
	  function initNelkoHeaderMegaAnimation() {
	    document.querySelectorAll('.nelko-home-header__mega-details').forEach(function initMegaDetails(details) {
	      const summary = details.querySelector('.nelko-home-header__mega-summary')

	      if (!summary) return

	      details.addEventListener('pointerenter', function onMegaPointerEnter() {
	        if (!isNelkoHeaderDesktopHoverMode()) return

	        openNelkoHeaderMega(details)
	      })

	      details.addEventListener('pointerleave', function onMegaPointerLeave() {
	        if (!isNelkoHeaderDesktopHoverMode()) return

	        scheduleNelkoHeaderMegaClose(details)
	      })

	      details.addEventListener('focusin', function onMegaFocusIn() {
	        if (!isNelkoHeaderDesktopHoverMode()) return

	        openNelkoHeaderMega(details)
	      })

	      details.addEventListener('focusout', function onMegaFocusOut(event) {
	        if (!isNelkoHeaderDesktopHoverMode()) return
	        if (event.relatedTarget && details.contains(event.relatedTarget)) return

	        scheduleNelkoHeaderMegaClose(details)
	      })

	      summary.addEventListener('click', function onMegaSummaryClick(event) {
	        event.preventDefault()

	        if (isNelkoHeaderDesktopHoverMode()) {
	          openNelkoHeaderMega(details)
	          return
	        }

	        if (details.open && !details.classList.contains('is-closing')) {
	          closeNelkoHeaderMega(details)
	          return
	        }

	        openNelkoHeaderMega(details)
	      })
	    })
	  }

	  if (!customElements.get('nelko-announcement-carousel')) {
	    class NelkoAnnouncementCarousel extends HTMLElement {
	      connectedCallback() {
	        if (this.isInitialized) return

	        this.isInitialized = true
	        this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'))
	        this.viewport = this.querySelector('[data-announcement-viewport]')
	        this.previousButton = this.querySelector('[data-announcement-previous]')
	        this.nextButton = this.querySelector('[data-announcement-next]')
	        this.currentIndex = Math.max(
	          this.slides.findIndex(function findActiveSlide(slide) {
	            return slide.classList.contains('is-active')
	          }),
	          0
	        )
	        this.autoplayEnabled = this.dataset.autoplay === 'true'
	        this.interval = Math.max(Number.parseInt(this.dataset.interval, 10) || 5000, 3000)
	        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
	        this.touchStartX = null

	        this.handlePrevious = this.showPrevious.bind(this)
	        this.handleNext = this.showNext.bind(this)
	        this.handleMouseEnter = () => {
	          this.isPointerOver = true
	          this.stopAutoplay()
	        }
	        this.handleMouseLeave = () => {
	          this.isPointerOver = false
	          this.startAutoplay()
	        }
	        this.handleFocusIn = () => {
	          this.hasFocusWithin = true
	          this.stopAutoplay()
	        }
	        this.handleFocusOut = this.onFocusOut.bind(this)
	        this.handleTouchStart = this.onTouchStart.bind(this)
	        this.handleTouchEnd = this.onTouchEnd.bind(this)
	        this.handleVisibilityChange = this.onVisibilityChange.bind(this)

	        this.previousButton?.addEventListener('click', this.handlePrevious)
	        this.nextButton?.addEventListener('click', this.handleNext)
	        this.addEventListener('mouseenter', this.handleMouseEnter)
	        this.addEventListener('mouseleave', this.handleMouseLeave)
	        this.addEventListener('focusin', this.handleFocusIn)
	        this.addEventListener('focusout', this.handleFocusOut)
	        this.addEventListener('touchstart', this.handleTouchStart, { passive: true })
	        this.addEventListener('touchend', this.handleTouchEnd, { passive: true })
	        document.addEventListener('visibilitychange', this.handleVisibilityChange)

	        this.showSlide(this.currentIndex, false)
	        this.startAutoplay()
	      }

	      disconnectedCallback() {
	        this.stopAutoplay()
	        this.previousButton?.removeEventListener('click', this.handlePrevious)
	        this.nextButton?.removeEventListener('click', this.handleNext)
	        this.removeEventListener('mouseenter', this.handleMouseEnter)
	        this.removeEventListener('mouseleave', this.handleMouseLeave)
	        this.removeEventListener('focusin', this.handleFocusIn)
	        this.removeEventListener('focusout', this.handleFocusOut)
	        this.removeEventListener('touchstart', this.handleTouchStart)
	        this.removeEventListener('touchend', this.handleTouchEnd)
	        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
	      }

	      showSlide(index, userInitiated) {
	        if (this.slides.length === 0) return

	        const normalizedIndex = (index + this.slides.length) % this.slides.length

	        this.slides.forEach(function updateSlide(slide, slideIndex) {
	          const isActive = slideIndex === normalizedIndex
	          slide.classList.toggle('is-active', isActive)
	          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true')
	          if (slide.matches('a[href]')) {
	            slide.tabIndex = isActive ? 0 : -1
	          } else {
	            slide.removeAttribute('tabindex')
	          }
	        })

	        this.currentIndex = normalizedIndex

	        if (this.viewport && userInitiated) {
	          this.viewport.setAttribute('aria-live', 'polite')
	          window.setTimeout(() => {
	            this.viewport?.setAttribute('aria-live', 'off')
	          }, 500)
	        }
	      }

	      showPrevious() {
	        this.showSlide(this.currentIndex - 1, true)
	        this.restartAutoplay()
	      }

	      showNext() {
	        this.showSlide(this.currentIndex + 1, true)
	        this.restartAutoplay()
	      }

	      startAutoplay() {
	        if (
	          !this.autoplayEnabled ||
	          this.reducedMotion ||
	          this.slides.length < 2 ||
	          this.isPointerOver ||
	          this.hasFocusWithin ||
	          document.hidden
	        ) return

	        this.stopAutoplay()
	        this.autoplayTimer = window.setInterval(() => {
	          this.showSlide(this.currentIndex + 1, false)
	        }, this.interval)
	      }

	      stopAutoplay() {
	        if (!this.autoplayTimer) return

	        window.clearInterval(this.autoplayTimer)
	        this.autoplayTimer = null
	      }

	      restartAutoplay() {
	        this.stopAutoplay()
	        this.startAutoplay()
	      }

	      onFocusOut(event) {
	        if (!event.relatedTarget || !this.contains(event.relatedTarget)) {
	          this.hasFocusWithin = false
	          this.startAutoplay()
	        }
	      }

	      onTouchStart(event) {
	        this.touchStartX = event.changedTouches[0]?.clientX ?? null
	        this.stopAutoplay()
	      }

	      onTouchEnd(event) {
	        if (this.touchStartX === null) return

	        const touchEndX = event.changedTouches[0]?.clientX ?? this.touchStartX
	        const distance = touchEndX - this.touchStartX
	        this.touchStartX = null

	        if (Math.abs(distance) >= 35) {
	          if (distance > 0) {
	            this.showSlide(this.currentIndex - 1, true)
	          } else {
	            this.showSlide(this.currentIndex + 1, true)
	          }
	        }

	        this.startAutoplay()
	      }

	      onVisibilityChange() {
	        if (document.hidden) {
	          this.stopAutoplay()
	        } else {
	          this.startAutoplay()
	        }
	      }
	    }

	    customElements.define('nelko-announcement-carousel', NelkoAnnouncementCarousel)
	  }

	  initNelkoHeaderDrawerAccordion()
	  initNelkoHeaderMegaScrollLock()
	  initNelkoHeaderMegaAnimation()
	  initNelkoHeaderSearchPanels()
	  initNelkoHeaderResponsiveStateSync()
	
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lvy-faq-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  function normalizeText(value) {
    return (value || '').toLowerCase().trim()
  }

  function filterFaqSections(query) {
    const normalizedQuery = normalizeText(query)
    const faqSections = document.querySelectorAll('.faq')
    let totalMatches = 0

    faqSections.forEach(function (section) {
      let sectionMatches = 0
      const categories = section.querySelectorAll('.faq__category')

      categories.forEach(function (category) {
        let categoryMatches = 0
        const items = category.querySelectorAll('[data-faq-item]')

        items.forEach(function (item) {
          const content = item.getAttribute('data-faq-search-content') || item.textContent || ''
          const matches = !normalizedQuery || normalizeText(content).includes(normalizedQuery)

          item.classList.toggle('is-search-hidden', !matches)
          if (matches) {
            categoryMatches += 1
            sectionMatches += 1
          }
        })

        category.classList.toggle('is-search-empty', !!normalizedQuery && categoryMatches === 0)
      })

      section.classList.toggle('is-search-active', !!normalizedQuery)
      totalMatches += sectionMatches
    })

    return totalMatches
  }

  document.querySelectorAll('[data-faq-search]').forEach(function (searchSection) {
    const form = searchSection.querySelector('[data-faq-search-form]')
    const input = searchSection.querySelector('[data-faq-search-input]')
    const emptyState = searchSection.querySelector('[data-faq-search-empty]')

    if (!form || !input) return

    function handleSearch() {
      const matchCount = filterFaqSections(input.value)
      const hasQuery = normalizeText(input.value).length > 0

      if (emptyState) {
        emptyState.hidden = !hasQuery || matchCount > 0
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault()
      handleSearch()
    })

    input.addEventListener('input', handleSearch)

    input.addEventListener('search', function () {
      if (!input.value) {
        handleSearch()
      }
    })
  })
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lvy-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.faq');

  sections.forEach(function (section) {
    const viewMoreButtons = section.querySelectorAll('[data-view-more]');

    viewMoreButtons.forEach(function (button) {
      const category = button.closest('.faq__category');
      if (!category) return;

      const hiddenItems = category.querySelectorAll('.faq__item.is-hidden');
      if (!hiddenItems.length) {
        button.remove();
        return;
      }

      const moreLabel = button.dataset.viewMoreLabel || 'View More';
      const lessLabel = button.dataset.viewLessLabel || 'View Less';

      button.addEventListener('click', function () {
        const isExpanded = button.classList.contains('is-expanded');

        if (isExpanded) {
          hiddenItems.forEach(function (item) {
            item.classList.add('is-hidden');
            item.classList.remove('is-visible');
          });
          button.classList.remove('is-expanded');
          button.setAttribute('aria-expanded', 'false');
          button.textContent = moreLabel;
        } else {
          hiddenItems.forEach(function (item) {
            item.classList.remove('is-hidden');
            item.classList.add('is-visible');
          });
          button.classList.add('is-expanded');
          button.setAttribute('aria-expanded', 'true');
          button.textContent = lessLabel;
        }
      });
    });

    section.querySelectorAll('.faq__question').forEach(function (summary) {
      summary.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          summary.click();
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lvy-product-guides"] && !Shopify.designMode) return;
  try {
    
(function () {
	document.querySelectorAll('.product-guides').forEach(function (section) {
		const tabs = section.querySelectorAll('[data-tab]');
		const panels = section.querySelectorAll('[data-panel]');

		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				const tabId = tab.getAttribute('data-tab');

				tabs.forEach(function (item) {
					item.classList.remove('is-active');
					item.setAttribute('aria-selected', 'false');
				});

				tab.classList.add('is-active');
				tab.setAttribute('aria-selected', 'true');

				panels.forEach(function (panel) {
					if (panel.getAttribute('data-panel') === tabId) {
						panel.classList.add('is-active');
						panel.removeAttribute('hidden');
					} else {
						panel.classList.remove('is-active');
						panel.setAttribute('hidden', '');
					}
				});
			});
		});
	});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lvy-quick_access"] && !Shopify.designMode) return;
  try {
    
(function () {
  function scrollToAnchor(targetId) {
    var target = document.getElementById(targetId)
    if (!target) return false

    target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + targetId)
    }
    return true
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-access-anchor]')
    if (!trigger) return

    var targetId = trigger.getAttribute('data-quick-access-anchor')
    if (!targetId) return

    if (scrollToAnchor(targetId)) {
      event.preventDefault()
    }
  })
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nelko-page-contact-us"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.faq');

  sections.forEach(function (section) {
    const viewMoreButtons = section.querySelectorAll('[data-view-more]');

    viewMoreButtons.forEach(function (button) {
      const category = button.closest('.faq__category');
      if (!category) return;

      const hiddenItems = category.querySelectorAll('.faq__item.is-hidden');
      if (!hiddenItems.length) {
        button.remove();
        return;
      }

      const moreLabel = button.dataset.viewMoreLabel || 'View More';
      const lessLabel = button.dataset.viewLessLabel || 'View Less';

      button.addEventListener('click', function () {
        const isExpanded = button.classList.contains('is-expanded');

        if (isExpanded) {
          hiddenItems.forEach(function (item) {
            item.classList.add('is-hidden');
            item.classList.remove('is-visible');
          });
          button.classList.remove('is-expanded');
          button.setAttribute('aria-expanded', 'false');
          button.textContent = moreLabel;
        } else {
          hiddenItems.forEach(function (item) {
            item.classList.remove('is-hidden');
            item.classList.add('is-visible');
          });
          button.classList.add('is-expanded');
          button.setAttribute('aria-expanded', 'true');
          button.textContent = lessLabel;
        }
      });
    });

    section.querySelectorAll('.faq__question').forEach(function (summary) {
      summary.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          summary.click();
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
